<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<section id="wrapper" class="login-register login-sidebar"
         style="background-image:url(../assets/images/background/13_portrait_02.jpg);">
    <div class="login-box card">
        <div class="card-body">
            <form class="form-horizontal form-material" #loginForm="ngForm" (ngSubmit)="login()">
                <a href="javascript:void(0)" class="text-center db"><img src="../assets/images/nuevoLogo.png"
                                                                         alt="Home"/><br/><img
                        src="../assets/images/logo-text.png" alt="Home"/></a>
                <div class="form-group has-danger m-t-40">
                    <div class="col-xs-12">
                        <input class="form-control" type="text"
                               #user="ngModel"
                               [(ngModel)]="usuario"
                               required
                               name="user"
                               [placeholder]="FORMS.login.username.placeholder"
                        >
                        <div *ngIf="!user.valid && user.touched"
                             class="form-control-feedback">{{ FORMS.login.required }}
                        </div>
                    </div>
                </div>
                <div class="form-group has-danger">
                    <div class="col-xs-12">
                        <input class="form-control" type="password"
                               #pass="ngModel"
                               [(ngModel)]="password"
                               required
                               name="pass"
                               [placeholder]="FORMS.login.password.placeholder"
                        >
                        <div *ngIf="!pass.valid && pass.touched"
                             class="form-control-feedback">{{ FORMS.login.required }}
                        </div>
                    </div>
                </div>
                <div class="form-group text-center m-t-20">
                    <div class="col-xs-12">
                        <button class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                                type="submit"
                                [disabled]="!loginForm.valid || loginLoader"
                        >
                            {{ FORMS.login.button }}
                            <i *ngIf="loginLoader" class="fa fa-spinner fa-pulse fa-fw"></i>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>
<!-- ============================================================== -->
<!-- End Wrapper -->
<!-- ============================================================== -->


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_pages/login/login.component.html